(function () {
    'use strict';
    
    angular
        .module('app')
        .controller('DisplayMessageController', DisplayMessageController)
        .controller('CountdownController', CountdownController)
        .controller('PermissionDeniedController', PermissionDeniedController);

    function DisplayMessageController($scope, $rootScope, $state, $localStorage, AuthenticationService) {
        var model = this;
        $localStorage.messageData = $rootScope.messageData;

        model.messageData = $rootScope.messageData;

        $scope.loaderClosed = function () {
            cfpLoadingBar.complete();
        }

        $scope.loaderStart = function () {
            cfpLoadingBar.start();
        }

        $scope.goToUserPage = function (data) {
            $state.go(data.pageName, data.params);
        }

    }

    function CountdownController($scope, $timeout, $state) {
        $scope.counter = 5;
        $scope.onTimeout = function () {
            
            if ($scope.counter > 1) {
                $scope.counter--;
                mytimeout = $timeout($scope.onTimeout, 1000);
            } else {
                //prevent state change if already routed away from page
                if ($state.current.name === 'displayMessage') {
                    $state.go('login');
                }
            }
        }
        var mytimeout = $timeout($scope.onTimeout, 1000);
    }

    function PermissionDeniedController($scope, $rootScope, cfpLoadingBar) {
        cfpLoadingBar.complete();
    }
})();
